import { Injectable } from '@angular/core';

@Injectable()
/**
 * Service for creating/retrieving route configurations
 */
export abstract class RouteConfigurationBaseService {

    constructor(
    ) {
    }

    /**
     * Get a route configuration by name
     */
    public abstract getRouteConfiguration(routeDefinitionType);

    /**
     * Get the default route configuration based on metadata
     */
    public abstract getDefaultRouteConfiguration(metadata): string;
}
